export function getToolCallFormData(toolCallId: string): string | undefined {
  // Get the form element inside the artifact panel
  const form = document.querySelector(
    `#artifact-panel-${toolCallId} .record-form, [data-form-id="${toolCallId}"]`
  ) as HTMLFormElement;

  if (!form) return undefined;

  const formData = new FormData(form);
  return new URLSearchParams(formData as any).toString();
}
